$('.featuredOn__logos').slick({
    autoplay: true,
    infinite: true,
    speed: 300,
    variableWidth: true,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    mobileFirst: true,
    centerMode: true,
    responsive: [
        {
            breakpoint: 991,
            settings: "unslick"
        }
    ]
});